import React from 'react';
import cls from 'classnames';
import './Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  fullWidth?: Boolean;
  variant?: string;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  variant,
  ...props
}) => (
  <button
    className={cls(className, 'lb_button', { lb_btn_text: variant === 'text' })}
    {...props}
  >
    {children}
  </button>
);
